import { CobranzasService } from './../../../../services/cobranzas/cobranzas.service';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Operacion } from '../../../../models/Operacion';
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatTableDataSource} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../../models/messages';
import { Proforma } from 'app/models/Proforma';


export const MY_FORMATS = {
    parse: {
        dateInput: "DD-MM-YYYY"
    },
    display: {
        dateInput: "DD-MM-YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY"
    }
};

declare var $: any;

@Component({
  selector: 'app-pagar-deuda',
  templateUrl: './pagar-deuda.component.html',
  styleUrls: ['./pagar-deuda.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates, Operacion, Proforma,
    DatePipe,
    {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
]
})
export class PagarDeudaComponent implements OnInit {


  @Input() arrayDeuda: any = [];
  @Output() cerrarPagarDeuda = new EventEmitter<boolean>();

  formularioCrearPago: FormGroup;
  user: any;
  loading: boolean = false;
  dataSource: any;
  dataSourceConDetalle: any;

  constructor(private msgTitulos: MessagesTitles, private cobranzaService : CobranzasService) {

      this.user = JSON.parse(sessionStorage.getItem('UserActive'));

      this.formularioCrearPago = new FormGroup({
          idDeuda: new FormControl(''),
          Pago_Ejecutar: new FormControl('')
      });
  }

  ngOnInit() {
      this.dataSource = new MatTableDataSource(this.arrayDeuda);
  }

  CerrarPopUp() {
      this.cerrarPagarDeuda.emit();
  }

  guardarPago() {
      
      for (let array of this.arrayDeuda) {
        if (parseFloat($("#" + array.idDeuda).val()) <= 0) {
                Swal.fire({
                  title: "Warning",
                  text: "Monto a pagar debe ser mayor a 0 ",
                  type: 'warning',
                  allowOutsideClick: true,
                  heightAuto: false
                })
                return false; 
        }
              this.formularioCrearPago.controls['idDeuda'].setValue(array.idDeuda);
              this.formularioCrearPago.controls['Pago_Ejecutar'].setValue(parseFloat($("#" + array.idDeuda).val()));
      }
      Swal.fire({
          title: '¿Desea continuar?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Continuar',
          cancelButtonText: 'No, Cancelar',
          heightAuto: false
      }).then((result) => {
          if (result.value) {
              Swal.fire({
                  title: "Espere...",
                  text: "Guardando información",
                  type: "info",
                  allowOutsideClick: false,
                  heightAuto: false
              });
              
              Swal.showLoading();
              this.cobranzaService.PagarDeuda(this.formularioCrearPago.getRawValue()).subscribe(
                  res => {
            
                      this.loading = false;
                      Swal.fire({
                          title: "Realizado",
                          text: "Pago guardado correctamente..",
                          type: "success",
                          allowOutsideClick: false,
                          heightAuto: false
                      }).then(resp => {
                          if (resp.value == true) {
                            this.cerrarPagarDeuda.emit();
                          }
                      });
                  }, err => {
                      if (err.error.code == 500) {
                          err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
                      }
                      Swal.fire({
                          title: this.msgTitulos.Error_Algo_Salio_Mal,
                          text: err.error.error,
                          type: "warning",
                          allowOutsideClick: false,
                          heightAuto: false
                      });
                      this.loading = false;
                  }
              );
          }
      });
  }



  validarInput() {
      for (let array of this.arrayDeuda) {
          if (parseFloat($("#" + array.idDeuda).val()) > parseFloat(array.Saldo_Importe)) {
              $("#" + array.idDeuda).val(array.Saldo_Importe);
          } else if (parseFloat($("#" + array.idDeuda).val()) < 0) {
              $("#" + array.idDeuda).val(0);
          }
      }
  }

  fullMount(idDeuda) {
      for (let array of this.arrayDeuda) {
          if (array.idDeuda == idDeuda) {
              if ($("#" + array.idDeuda).val() == array.Saldo_Importe) {
                  $("#" + array.idDeuda).val(0);
              } else {
                  $("#" + array.idDeuda).val(array.Saldo_Importe);
              }
          }
      }

  }

}
